/*eslint-disable */
//ANCHOR class/month filter to this view: DONE

import apiClient from "@/services/axios";
import { mapState } from "vuex";
import "jspdf-autotable";
import { notification } from "ant-design-vue";
import moment from "moment";
import FinalBulletin from "../components/FinalBulletin.vue";
import AllFinalBulletin from "../components/AllFinalBulletin.vue";
import Bulletin from "../components/Bulletin.vue";
import AIFeedback from "../components/AIFeedback.vue";
import stats from "../components/stats.vue";
const pvPrintHelper = require("./bulletinHeplers/pv").default;
import defaultTemplate from "./bulletinHeplers/templates/default.json";
const printPvClass = require("@/views/parametrage/bulletin/components/ConsielClass/pvClass").default;
import { resolveStudentMarksPrintConfig } from "@/views/parametrage/bulletin/components/ConsielClass/builtinTemplates";
import { buildConseilPvSchoolInfo } from "@/views/parametrage/bulletin/components/ConsielClass/pvSchoolInfo";
const bulletinHelper = {
  MP: require("./bulletinHeplers/peda").default,
  MT: require("./bulletinHeplers/bulletin").default,
  MS: require("./bulletinHeplers/bulletin").default,
  custom: require("./bulletinHeplers/custom/").default,
};
const customYearlyBt = require("./bulletinHeplers/custom/AC_CP_yearly").default;
import markHistoryMixin from "../../mixins/markHistoryMixin";
import { showApiError } from "@/utilities/showApiError";
import { isPrimarySchoolType } from "@/config/Constants";

export default {
  mixins: [markHistoryMixin],
  props: {
    type: {
      type: String,
      required: true,
    },
    subModuleList: {
      type: Array,
      required: true,
    },
  },
  components: {
    FinalBulletin,
    AllFinalBulletin,
    stats,
    Bulletin,
    AIFeedback,
  },
  computed: {
    ...mapState(["settings", "user"]),
    activeStudentsList() {
      return this.activeData.filter(
        (student) => (student.status || "active") !== "inactive"
      );
    },
    archivedStudentsList() {
      return this.activeData.filter(
        (student) => (student.status || "active") === "inactive"
      );
    },
    countryIsTN() {
      const code =
        this.schoolDetails?.countryCode ||
        (
          this.user.building.find(
            (el) => el.dbName == this.settings.activeBuilding
          ) || {}
        ).countryCode;
      return code == "TN";
    },
    isPrimarySchool() {
      const types = this.schoolDetails?.type ?? this.schoolType;
      return isPrimarySchoolType(types);
    },
    canPrintConseilClass() {
      return (
        this.countryIsTN &&
        this.isPrimarySchool &&
        this.selectedClasse &&
        this.selectedClasse !== "all"
      );
    },
    columns() {
      return [
        {
          title: this.$t("bulletin.matieres"),
          dataIndex: "name",
          key: "name",
          scopedSlots: {
            customRender: "name",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) =>
            record.name.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("bulletin.note"),
          dataIndex: "note",
          scopedSlots: { customRender: "note" },
        },
        {
          title: this.$t("action.actions"),
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ];
    },
    schoolAccessTemplateID() {
      //specefic template are only available in bulletin specific
      if (this.type !== "MS") return "";
      //! Important: the commented templates are the one can be reproduced with the bulletin builder
      const accessTemplates = [
        //{ id: "MS", dbName: "MalekEssaghir" },
        { id: "MD", dbName: "mondialPrimaire" },
        //{ id: "AC", dbName: "arcEnCiel" },
        //{ id: "CP", dbName: "coupolePrimaire" }, //Coupole EDWEB-1155
        //{ id: "CP", dbName: "coupoleLycee" }, //Coupole EDWEB-1155
        //{ id: "EV", dbName: "everestAcademy" }, //Everest EDWEB-1166
        //{ id: "CP", dbName: "learnToFly" }, //learntofly EDWEB-1170
        { id: "PY", dbName: "pythagorePrimaire" }, //Pythagore Primaire EDWEB-1169
        //{ id: "HC", dbName: "harmonySchool" }, //harmonySchool EDWEB-1180
        //{ id: "BO", dbName: "BaherAloum" }, //Bahr El Ouloum EDWEB-1508
        { id: "MJ", dbName: "ecoleMahjoub" },
        { id: "MB", dbName: "almanehelSfax" },
        { id: "MB", dbName: "school1" },
        { id: "MB", dbName: "school1Dev" },
        { id: "MB", dbName: "school1Stg" },
      ];
      let templateId = accessTemplates.find(
        (e) => e.dbName == this.schoolDetails.dbName
      );
      templateId = templateId ? templateId.id : "";
      //templateId = "MB"; // DEV ONLY: return to templateId after development
      return templateId;
    },
    schoolAccessYearlyTemplateID() {
      const accessTemplates = [
        { id: "AC", dbName: "arcEnCiel2" },
        { id: "CP", dbName: "coupolePrimaire" },
        { id: "CP", dbName: "coupoleLycee" },
      ];
      let templateId = accessTemplates.find(
        (e) => e.dbName == this.schoolDetails.dbName
      );
      templateId = templateId ? templateId.id : "";
      //templateId = "AC";
      return templateId;
    },
    defaultAttendancePeriod() {
      switch (this.selectedTrimester) {
        case "1":
          return [moment("2024-09-01"), moment("2025-12-31")];
        case "2":
          return [moment("2024-12-01"), moment("2025-03-31")];
        case "3":
          return [moment("2025-03-01"), moment("2025-06-30")];
      }
    },
    groupBulletin() {
      return this.menuItems.filter(
        (item) => item.group === "g1" && (!item.condition || item.condition())
      );
    },
    groupAnnuel() {
      return this.menuItems.filter(
        (item) => item.group === "g2" && (!item.condition || item.condition())
      );
    },
    groupPV() {
      return this.menuItems.filter(
        (item) => item.group === "g5" && (!item.condition || item.condition())
      );
    },
    groupPVExcel() {
      return this.menuItems.filter(
        (item) => item.group === "g6" && (!item.condition || item.condition())
      );
    },
    groupPVAnnuel() {
      return this.menuItems.filter(
        (item) => item.group === "g3" && (!item.condition || item.condition())
      );
    },
    groupWithTemplate() {
      return this.menuItems.filter(
        (item) => item.group === "g4" && (!item.condition || item.condition())
      );
    },
    groupYearlyWithTemplate() {
      return this.menuItems.filter(
        (item) => item.group === "g7" && (!item.condition || item.condition())
      );
    },
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.confirmLeaveReload);
  },
  async created() {
    window.addEventListener("beforeunload", this.confirmLeaveReload);
    this.tableLoading = true;
    this.defaultAffichageData = defaultTemplate;
    let project = {
      _id: 1,
      name: 1,
      level: 1,
    };
    project[this.bulletinType(2)] = 1;
    await apiClient
      .post("/classrooms/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: project,
        },
      })
      .then((res) => (this.classes = res.data));
    this.tableLoading = false;
    this.filtredTable = this.activeData;

    this.schoolDetails = this.user.building.filter(
      (el) => el.dbName == this.settings.activeBuilding
    )[0];

    let { start, end } = this.settings.schoolarYears.find(
      (el) => el._id == this.settings.activeSchoolarYear
    );

    start = new Date(start).getFullYear();
    end = new Date(end).getFullYear();

    this.schoolarYearName = end + " / " + start;

    this.schoolType = this.user.building.filter(
      (el) => el.dbName == this.settings.activeBuilding
    )[0].type;
    if (!this.schoolType)
      notification.warning({
        message: this.$t("bulletin.typeIntrouvable"),
        description: this.$t("bulletin.saisirSchoolType"),
      });
    apiClient
      .get(`/buildings/${this.settings.activeBuildingId}/stamp`)
      .then(({ data }) => {
        this.stamp = data?.imageURL
          ? this.settings.base_url + "/" + data.imageURL
          : null;
      })
      .catch((e) => null);
    const arrayOfImages = this.settings.image;
    for (var i = 0; i < arrayOfImages.length; i++) {
      if (this.settings.activeBuilding === arrayOfImages[i].db) {
        this.logo = arrayOfImages[i].logo;
      }
    }
    await this.updateCertifParams();
    this.getIncompleteMarks();
  },

  data() {
    return {
      visiblePrePvHandlers: false,
      pvHandlerConf: {
        on: "trim",
        key: "1",
      },
      pvSort: {
        by: "moyenne",
        order: "desc",
      },
      bulletinPreviewer: {
        on: "student",
        selectedItem: "",
        students: [],
        incompleteMarksStats: {},
        selectedTrimester: "1",
        type: "MS",
        personalized: false,
        visible: false,
      },
      // AI feedback is off while /api/n8n is unmounted (EDWEB-5116): its result
      // callback (PUT /api/n8n/bulletin/feedback) no longer exists.
      aiFeedbackEnabled: false,
      studnetN8nFeedback: null,
      studentN8nGenerateLoading: false,
      yearlyConfig: {
        showStamp: true,
        usePersonalizedAverage: false,
        bulletinDate: new Date(),
      },
      teachersAccess: [],
      loadingBulletin: false,
      studentsData: [],
      listModules: [],
      bulletin: {},
      externalSubjectList: [],
      studentLoading: false,
      visibleBulletinDate: false,
      bulletinDate: new Date(),
      updatedChanges: true,
      printLoading: false,
      syncLoading: false,
      syncSubjectLoading: false,
      visibleClassnameList: false,
      visibleSubjectList: false,
      visibleFinalBulletin: false,
      visibleAllFinalBulletin: false,
      schoolType: null,
      filtredTable: [],
      incompleteMarksStats: {},
      selectedStudent: "",
      selectedStudentName: "",
      bulletins: { students: [] },
      selectedClassName: "",
      markData: [],
      originalMarkData: [],
      activeModule: null,
      bulletinData: [],
      certifParams: [],
      moduleLoading: false,
      selectedTrimester: "1",
      selectedClasse: null,
      tableLoading: false,
      saveLoading: false,
      activeData: [],
      markRefs: [],
      filters: {
        classe: false,
        classe_val: null,
        month: false,
        month_val: null,
      },
      rowData: [],
      data1: null,
      classes: [],
      editable: false,
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      subsubjectData: [],
      subjectList: [],
      selectedLevel: null,
      schoolDetails: {},
      schoolarYearName: "",
      usePersonalizedAverage: false,
      personalized: false,
      exemptStudents: [],
      menuItems: [
        {
          key: "1",
          label: "bulletin.imprimerBulletin",
          group: "g1",
          action: "bulletinSwitcher",
          params: ["1"],
          condition: () => this.selectedStudent,
        },
        {
          key: "2",
          label: "bulletin.imprimerTout",
          group: "g1",
          action: "bulletinSwitcher",
          params: ["2"],
        },
        {
          key: "3",
          label: "bulletin.imprimerBulletin",
          group: "g2",
          action: "openFinalBulletin",
          condition: () => this.selectedStudent,
        },
        {
          key: "4",
          label: "bulletin.imprimerTout",
          group: "g2",
          action: "openAllFinalBulletin",
        },
        {
          key: "5",
          label: "bulletin.imprimerPV",
          group: "g3",
          action: "showPvHandlers",
          params: [{ on: "yearly" }],
        },
        {
          key: "6",
          label: "bulletin.imprimerPVParNiveau",
          group: "g3",
          action: "showPvHandlers",
          params: [{ on: "yearly" }],
        },
        {
          key: "7",
          label: "bulletin.imprimerBulletin",
          group: "g4",
          action: "bulletinSwitcher",
          params: ["1", () => this.schoolAccessTemplateID],
          condition: () => this.selectedStudent,
        },
        {
          key: "8",
          label: "bulletin.imprimerTout",
          group: "g4",
          action: "bulletinSwitcher",
          params: ["2", () => this.schoolAccessTemplateID],
        },
        {
          key: "13",
          label: "bulletin.imprimerBulletin",
          group: "g7",
          action: "bulletinSwitcher",
          params: ["3", () => this.schoolAccessYearlyTemplateID],
          condition: () => this.selectedStudent,
        },
        {
          key: "14",
          label: "bulletin.imprimerTout",
          group: "g7",
          action: "bulletinSwitcher",
          params: ["4", () => this.schoolAccessYearlyTemplateID],
        },
        {
          key: "9",
          label: "bulletin.imprimerPV",
          group: "g5",
          action: "showPvHandlers",
          params: [
            {
              on: "trim",
              key: "1",
            },
          ],
        },
        {
          //pv excel
          key: "11",
          label: "bulletin.imprimerPV",
          group: "g6",
          //action: "printPvHandler",
          //params: ["2"],
          action: "showPvHandlers",
          params: [
            {
              on: "trim",
              key: "2",
            },
          ],
        },
        {
          key: "10",
          label: "bulletin.imprimerPVParNiveau",
          group: "g5",
          action: "showPvHandlers",
          params: [
            {
              on: "trim",
              key: "3",
            },
          ],
        },
        {
          //pv excel
          key: "12",
          label: "bulletin.imprimerPVNiveaux",
          group: "g6",
          action: "showPvHandlers",
          params: [
            {
              on: "trim",
              key: "4",
            },
          ],
        },
      ],
      selectedPrintKey: null,
      showStamp: true,
      showDate: true,
      defaultAffichageData: {},
      affichageData: {},
      stamp: null,
      logo: null,
    };
  },

  beforeRouteLeave(to, from, next) {
    const _this = this;

    if (this.updatedChanges) next();
    else
      this.$confirm({
        title: this.$t("all.unsavedchanges"),
        content: this.$t("all.unsavedchangesContent"),
        okText: this.$t("all.oui"),
        okType: "danger",
        cancelText: this.$t("action.annuler"),
        onOk() {
          _this.updatedChanges = true;
          next();
        },
        onCancel() {
          next(false);
        },
      });
  },
  methods: {
    async customBulletinAdder(studentsID) {
      if (this.schoolAccessTemplateID == "MJ") {
        let attendanceData = {};
        try {
          const { data } = await apiClient.post("attendance/filter", {
            query: {
              student: {
                $in: studentsID,
              },
              date: {
                $gte: this.defaultAttendancePeriod[0],
                $lte: this.defaultAttendancePeriod[1],
              },
              schoolarYear: this.settings.activeSchoolarYear,
            },
          });
          data.forEach((el) => {
            if (attendanceData[el.student])
              attendanceData[el.student] = {
                latence: el.type == "Absence" ? 1 : 0,
                retard: el.type == "Retard" ? 1 : 0,
              };
            else
              attendanceData[el.student] = {
                latence: el.type == "Absence" ? 1 : 0,
                retard: el.type == "Retard" ? 1 : 0,
              };
          });
        } catch (error) {
          console.error("Failed to fetch attendance data:", error);
        }
        const students = this.bulletinData;
        const classInfo = {
          className: this.selectedClassName,
          trimester: this.selectedTrimester,
          schoolarYear: this.schoolarYearName,
        };
        return [students, classInfo, null, null, attendanceData];
      }
    },
    async showPvHandlers(params) {
      this.pvHandlerConf = {
        ...this.pvHandlerConf,
        ...params,
      };
      this.visiblePrePvHandlers = true;
    },
    closePvHandlers() {
      this.visiblePrePvHandlers = false;
      this.printLoading = false;
    },
    async pvHandlers() {
      this.visiblePrePvHandlers = false;
      if (this.pvHandlerConf.on == "trim")
        await this.printPvHandler(this.pvHandlerConf.key);
      else if (this.pvHandlerConf.on == "yearly") await this.yearlyPv();
      else this.closePvHandlers();
    },
    resetN8nFeedback() {
      this.studnetN8nFeedback = null;
    },
    bulletinHasStudentMarks() {
      if (!this.bulletin?.modules?.length) return false;
      return this.bulletin.modules.some((module) =>
        (module.subjects || []).some((subject) => {
          const mark = subject.mark;
          return (
            mark &&
            mark !== "--" &&
            mark !== "معفى" &&
            !Number.isNaN(Number(mark))
          );
        })
      );
    },
    async getAIRecommandation(alert = false, fetchFeedback = false) {
      if (!this.bulletinHasStudentMarks()) {
        this.$message.warning(
          this.$t("errorCode.NO_GRADES_FOR_TRIMESTER")
        );
        return;
      }

      this.studentN8nGenerateLoading = true;

      await apiClient
        .post("/bulletin/v2/n8n/trigger-webhook", {
          bulletinData: this.bulletin,
          student: this.selectedStudent,
          trimester: Number(this.selectedTrimester),
          type: this.type,
        })
        .then(({ data }) => {
          this.$message.info(this.$t("aiFeedback.initiatedMessage"));
          if (fetchFeedback) this.getBulletinFeedback();
        })
        .catch((error) => {
          console.error("Error sending AI request:", error);
          showApiError(this, error);
        })
        .finally(() => {
          this.studentN8nGenerateLoading = false;
        });
    },
    async getBulletinFeedback() {
      apiClient
        .get(
          `/bulletin/v2/n8n/feedback/${this.type}/${this.selectedStudent}/${this.selectedTrimester}`
        )
        .then(({ data }) => {
          this.studnetN8nFeedback = data || null;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async yearlyPv() {
      if (this.selectedPrintKey == "5") {
        // classroom
        ///bulletin/v2/pv/yearly/classroom/MS/671d07f85e54f4778c0c9305/3
        await apiClient
          .get(
            `/bulletin/v2/pv/yearly/classroom/${this.type}/${this.selectedClasse}/3`
          )
          .then(async ({ data }) => {
            await pvPrintHelper.printPVAnnuel(data, {
              settings: this.settings,
              usePersonalizedAverage: this.usePersonalizedAverage,
              type: this.type,
            });
          })
          .catch((e) => {
            console.log(e);
            this.$message.error(this.$t("error.erreur"));
          });
      } else if (this.selectedPrintKey == "6") {
        // level
        // /bulletin/v2/pv/yearly/level/MS/6/3
        await apiClient
          .get(
            `/bulletin/v2/pv/yearly/level/${this.type}/${this.selectedLevel}/3`
          )
          .then(async ({ data }) => {
            await pvPrintHelper.printPVAnnuelByLevel(data, {
              settings: this.settings,
              usePersonalizedAverage: this.usePersonalizedAverage,
              level: this.selectedLevel,
              type: this.type,
            });
          })
          .catch((e) => {
            console.log(e);
            this.$message.error(this.$t("error.erreur"));
          });
      }
      this.printLoading = false;
    },
    async printConseilClass() {
      if (!this.selectedClasse || this.selectedLevel == null) {
        this.$message.warning(this.$t("conseilClass.selectClassFirst"));
        this.printLoading = false;
        return;
      }
      this.printLoading = true;
      try {
        const config = await resolveStudentMarksPrintConfig(apiClient, {
          level: this.selectedLevel,
          type: this.type,
          schoolarYear: this.settings.activeSchoolarYear,
        });

        const { data: classPvData } = await apiClient.get(
          `/bulletin/v2/pv/conseil_class/${this.type}/${this.selectedClasse}`
        );

        const { data: studentsYearsLevel } = await apiClient.get(
          `/bulletin/v2/decision-conseil/classroom/${this.selectedClasse}/${this.settings.activeSchoolarYear}`
        );

        const info = await buildConseilPvSchoolInfo(
          this.settings,
          this.schoolDetails
        );

        const blobUrl = await printPvClass(config, classPvData, info, studentsYearsLevel);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${this.$t("bulletin.ConsielClass")} ${this.selectedClassName}.pdf`;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t("conseilClass.couldNotGetClassPv"));
      } finally {
        this.printLoading = false;
      }
    },
    //1st call on btn click
    async prePrintPdfHandler(key) {
      console.log("prePrintPdfHandler", key);
      this.selectedPrintKey = key;

      this.$gtag.event("Imp bulletin", {
        event_category: "Impression PDF",
        event_label: "Bulletin peda-NotesEleves section",
        value: 1,
      });

      this.printLoading = true;
      let noDateModelKeys = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
      if (noDateModelKeys.includes(Number(key)))
        return this.pdfFunctionSelector(key);
      this.visibleBulletinDate = true;
    },
    //2nd call on btn click
    handleOkDateModal() {
      this.visibleBulletinDate = false;
      this.pdfFunctionSelector(this.selectedPrintKey);
    },
    handleCancelDateModal() {
      this.visibleBulletinDate = false;
      this.printLoading = false;
      this.showStamp = true;
      this.bulletinDate = null;
    },
    //3rd call on btn click
    pdfFunctionSelector(key) {
      console.log("pdfFunctionSelector", key);
      const menuItem = this.menuItems.find((item) => item.key === key);
      if (menuItem && typeof this[menuItem.action] === "function") {
        const params = (menuItem.params || []).map((param) =>
          typeof param === "function" ? param() : param
        );
        console.log("menuItem", menuItem);
        this[menuItem.action](...params);
      }
    },
    async prePrintBulletin(templateId = "") {
      let addedConfig = {
        selectedLevel: this.selectedLevel,
        schoolDetails: this.schoolDetails,
        selectedStudent: this.selectedStudent,
        bulletinDate: this.bulletinDate,
        certifs: this.certifParams,
        selectedClassName: this.selectedClassName,
        schoolarYearName: this.schoolarYearName,
        type: this.bulletinType(1),
        bulletinType: this.type,
        selectedTrimester: this.selectedTrimester,
        selectedStudentName: this.selectedStudentName,
        settings: this.settings,
        selectedClasse: this.selectedClasse,
        studentsData: this.rowData,
        showStamp: this.showStamp,
        showDate: this.showDate,
      };
      let bulletinData, affichageData, studentData;
      // Fetching bulletin data
      bulletinData = this.bulletinData;
      affichageData = this.affichageData;
      studentData = this.rowData.find((s) => s._id === this.selectedStudent);
      const customBT = this.type == "MS" && templateId;
      this.printLoading = true;
      try {
        if (customBT) {
          if (templateId == "MJ") {
            const params = await this.customBulletinAdder([
              this.selectedStudent,
            ]);
            await bulletinHelper.custom[templateId].drawBulletin(...params);
          } else {
            if (templateId == "MB") {
              bulletinHelper.custom[templateId].printBulletin(
                bulletinData,
                this.teachersAccess
              );
            }
            else {
              await bulletinHelper.custom[templateId].printBulletin(
                affichageData,
                studentData,
                bulletinData,
                {
                  ...addedConfig,
                  ...this.user,
                  certifs: this.certifParams,
                }
              );
            }

          }
        } else {
          //### adapt config
          if (this.showStamp) {
            await apiClient
              .get(`/buildings/${this.settings.activeBuildingId}/stamp`)
              .then(({ data }) => {
                affichageData.side.stamp = data?.imageURL
                  ? data.imageURL
                  : null;
              })
              .catch((e) => console.error(e));
          } else {
            affichageData.side.stamp = null;
          }
          const config =
            this.type === "MP"
              ? [
                affichageData,
                studentData,
                bulletinData,
                {
                  ...addedConfig,
                  ...this.user,
                  certifs: this.certifParams,
                },
              ]
              : [
                affichageData,
                studentData,
                bulletinData,
                {
                  date: this.bulletinDate,
                  showDate: this.showDate,
                  ...this.settings,
                  ...this.user,
                  certifs: this.certifParams,
                },
              ];
          await bulletinHelper[this.type].printBulletin(...config);
        }
      } catch (error) {
        console.error("Failed to print bulletin:", error);
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.printLoading = false;
      }
    },
    async prePrintAllBulletin(templateId = "") {
      let affichageData = this.affichageData;
      let studentsData = this.studentsData;
      let bulletinsData = this.bulletinData;

      let addedConfig = {
        selectedLevel: this.selectedLevel,
        schoolDetails: this.schoolDetails,
        selectedStudent: this.selectedStudent,
        bulletinDate: this.bulletinDate,
        certifs: this.certifParams,
        selectedClassName: this.selectedClassName,
        schoolarYearName: this.schoolarYearName,
        type: this.bulletinType(1),
        bulletinType: this.type,
        selectedTrimester: this.selectedTrimester,
        selectedStudentName: this.selectedStudentName,
        settings: this.settings,
        selectedClasse: this.selectedClasse,
        studentsData: this.rowData,
        showStamp: this.showStamp,
        showDate: this.showDate,
      };

      if (this.showStamp) {
        await apiClient
          .get(`/buildings/${this.settings.activeBuildingId}/stamp`)
          .then(({ data }) => {
            affichageData.side.stamp = data?.imageURL ? data.imageURL : null;
          })
          .catch((e) => console.error(e));
      } else {
        affichageData.side.stamp = null;
      }

      try {
        const config =
          this.type === "MP"
            ? [
              affichageData,
              bulletinsData,
              {
                ...addedConfig,
                ...this.user,
                certifs: this.certifParams,
              },
            ]
            : [
              affichageData,
              studentsData,
              bulletinsData,
              {
                date: this.bulletinDate,
                showDate: this.showDate,
                ...this.settings,
                ...this.user,
                certifs: this.certifParams,
              },
            ];

        const customBT = this.type == "MS" && templateId;
        this.printLoading = true;
        if (customBT) {
          if (templateId == "MJ") {
            const params = await this.customBulletinAdder(
              this.bulletinData.map((b) => b.id)
            );
            await bulletinHelper.custom[templateId].drawAllBulletins(...params);
          } else {
            if (templateId == "MB") {
              bulletinHelper.custom[templateId].printAllBulletin(
                bulletinsData,
                this.teachersAccess
              );
            }
            else {
              await bulletinHelper.custom[templateId].printAllBulletin(
                affichageData,
                studentsData,
                bulletinsData,
                {
                  ...addedConfig,
                  ...this.user,
                  certifs: this.certifParams,
                }
              );
            }

          }
        } else await bulletinHelper[this.type].printAllBulletin(...config);
      } catch (error) {
        console.error("Failed to fetch or print bulletins:", error);
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.printLoading = false;
      }
    },
    closeBulletinHandler() {
      this.bulletinPreviewer.visible = false;
      this.pdfLoading = false;
    },
    async prePrintBulletinHandler(
      templateId = "",
      showStamp = false,
      bulletinDate = null,
      showDate = true
    ) {
      this.pdfLoading = true;
      this.bulletinPreviewer.visible = false;
      if (showStamp !== undefined) this.showStamp = showStamp;
      if (bulletinDate) this.bulletinDate = bulletinDate;
      if (showDate !== undefined) this.showDate = showDate;
      else this.bulletinDate = new Date();
      if (this.bulletinPreviewer.on === "student") {
        await this.prePrintBulletin(templateId);
      } else {
        await this.prePrintAllBulletin(templateId);
      }
      this.pdfLoading = false;
    },
    async bulletinSwitcher(key, templateId = "") {
      let params;
      this.printLoading = true;
      try {
        switch (key) {
          case "1":
            try {
              let response;
              if (this.type == "MS" && templateId == "MJ") {
                response = await apiClient.get(
                  `/bulletin/v2/bt/MJ/${this.type}/student/${this.selectedStudent}/${this.selectedTrimester}`
                );
                response = response.data;
              } else {
                response = await apiClient.get(
                  `/bulletin/v2/bt/${this.type}/${this.selectedStudent}/${this.selectedTrimester}`
                );
                response = response.data;
              }
              this.bulletinData = response;
            } catch (error) {
              console.error("Failed to fetch bulletin data:", error);
              this.printLoading = false;
              return;
            }
            this.bulletinPreviewer = {
              visible: true,
              on: "student",
              selectedItem: this.selectedStudent,
              students: this.bulletinData,
              incompleteMarksStats: this.incompleteMarksStats,
              selectedTrimester: this.selectedTrimester,
              type: this.type,
              personalized: this.personalized,
              templateId: templateId,
              allowPersonalizedAverage: false,
              allowStampField:
                this.schoolDetails &&
                this.schoolDetails.stamp &&
                this.schoolDetails.stamp !== "",
            };
            break;
          case "2":
            this.bulletinData = [];
            this.studentsData = [];
            try {
              let response;
              if (this.type == "MS" && templateId == "MJ") {
                response = await apiClient.get(
                  `/bulletin/v2/bt/MJ/${this.type}/classroom/${this.selectedClasse}/${this.selectedTrimester}`
                );
                response = response.data;
              } else {
                response = await apiClient.get(
                  `/bulletin/v2/bt/${this.type}/all/${this.selectedClasse}/${this.selectedTrimester}`
                );
                response = response.data;
              }

              // Check if response has students array
              if (
                !response ||
                !response.students ||
                !Array.isArray(response.students)
              ) {
                this.$message.warning(this.$t("bulletin.noValidBulletins"));
                this.printLoading = false;
                return;
              }

              // Process each student's bulletin
              for (const bulletinData of response.students) {
                if (!bulletinData || !bulletinData.modules) {
                  console.log(
                    "Skipping bulletin - missing data:",
                    bulletinData
                  );
                  continue;
                }

                // Find matching student data
                let studentData = this.rowData.find(
                  (s) => s._id === bulletinData.id
                );
                if (!studentData) {
                  studentData = {
                    _id: bulletinData.id,
                    key: bulletinData.id,
                    fullName: bulletinData.fullName || "",
                    classroom:
                      bulletinData.classroomName || this.selectedClassName,
                    classroom_id: this.selectedClasse,
                    gender: bulletinData.gender || null,
                    photo: null,
                    status: "active",
                  };
                }

                if (
                  (studentData.status || "active") === "inactive"
                ) {
                  continue;
                }

                this.studentsData.push(studentData);
                this.bulletinData.push(bulletinData);
              }

              console.log("Final print list:", {
                totalStudents: this.studentsData.length,
                studentNames: this.studentsData,
              });
            } catch (error) {
              console.error("Failed to fetch bulletin data:", error);
              this.printLoading = false;
              return;
            }
            this.bulletinPreviewer = {
              visible: true,
              on: "classroom",
              selectedItem: this.selectedClasse,
              students: this.bulletinData,
              incompleteMarksStats: this.incompleteMarksStats,
              selectedTrimester: this.selectedTrimester,
              type: this.type,
              personalized: this.personalized,
              templateId: templateId,
              allowPersonalizedAverage: false,
              allowStampField:
                this.schoolDetails &&
                this.schoolDetails.stamp &&
                this.schoolDetails.stamp !== "",
            };
            break;
          case "3":
            let bulletin;
            await apiClient
              .get(
                `/bulletin/v2/bt/yearly/3/${this.type}/${this.selectedStudent}`
              )
              .then((res) => (bulletin = res.data));
            params = {
              bulletin,
              details: {
                schoolName: this.schoolDetails.ArabicName,
                delegeRegional: this.schoolDetails.delegeRegional,
                schoolarYear: this.schoolarYearName,
                level: this.selectedLevel,
                logo: this.logo,
                stamp: this.stamp,
              },
              templateID: this.schoolAccessYearlyTemplateID,
            };
            await customYearlyBt.printBulletin(params);
            break;
          case "4":
            let bulletins;
            await apiClient
              .get(
                `/bulletin/v2/bt/yearly/classroom/3/${this.type}/${this.selectedClasse}`
              )
              .then((res) => (bulletins = res.data));
            params = await {
              bulletins,
              details: {
                schoolName: this.schoolDetails.ArabicName,
                className: this.selectedClassName,
                delegeRegional: this.schoolDetails.delegeRegional,
                schoolarYear: this.schoolarYearName,
                level: this.selectedLevel,
                logo: this.logo,
                stamp: this.stamp,
              },
              templateID: this.schoolAccessYearlyTemplateID,
            };
            await customYearlyBt.printAllBulletin(params);
            break;
        }
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.printLoading = false;
      }
    },
    async fetchAffichageBulletin() {
      this.affichageData = this.defaultAffichageData;
      if (!this.selectedLevel) return;
      await apiClient
        .post("/bulletin/v2/affichage/list", {
          status: "active",
          isTemplate: false,
          level: Number(this.selectedLevel),
          trimester: Number(this.selectedTrimester),
          schoolarYear: String(this.settings.activeSchoolarYear),
          type: String(this.type),
        })
        .then(({ data }) => {
          if (data.length > 0) {
            this.affichageData = data[0];
          } else {
            this.affichageData.type = this.type;
            this.affichageData.trimester = this.selectedTrimester;
            this.$message.info(this.$t("bulletin.noTemplateFound"));
          }
        })
        .catch((e) => {
          console.error(e);
          this.$message.error(this.$t("bulletin.noTemplateFound"));
        });
    },

    async printPvHandler(which) {
      let config = {
        selectedLevel: this.selectedLevel,
        schoolDetails: this.schoolDetails,
        selectedStudent: this.selectedStudent,
        bulletinDate: this.bulletinDate,
        certifs: this.certifParams,
        selectedClassName: this.selectedClassName,
        schoolarYearName: this.schoolarYearName,
        type: this.bulletinType(1),
        bulletinType: this.type,
        selectedTrimester: this.selectedTrimester,
        selectedStudentName: this.selectedStudentName,
        settings: this.settings,
        selectedClasse: this.selectedClasse,
        sortBy: this.pvSort.by,
        sortOrder: this.pvSort.order,
        usePersonalizedAverage:
          this.type === "MS" ? this.usePersonalizedAverage : false,
        document,
      };
      this.printLoading = true;

      try {
        switch (which) {
          case "1":
            this.$gtag.event("Imp PV Bulletin", {
              event_category: "Impression PDF",
              event_label: "Bulletin peda-NotesEleves section",
              value: 1,
            });
            await pvPrintHelper.printPVBulletin(config);
            break;
          case "2":
            this.$gtag.event("Imp PV Bulletin by level", {
              event_category: "Impression PDF",
              event_label: "Bulletin peda-NotesEleves section",
              value: 1,
            });
            await pvPrintHelper.printPVBulletinExcel({
              ...config,
              onLevel: false,
            });
            break;
          case "3":
            this.$gtag.event("Imp PV Bulletin by level", {
              event_category: "Impression PDF",
              event_label: "Bulletin peda-NotesEleves section",
              value: 1,
            });
            await pvPrintHelper.printPVBulletinLevel(config);
            break;
          case "4":
            this.$gtag.event("Imp PV Bulletin by level", {
              event_category: "Impression PDF",
              event_label: "Bulletin peda-NotesEleves section",
              value: 1,
            });
            await pvPrintHelper.printPVBulletinExcel({
              ...config,
              onLevel: true,
            });
            break;
        }
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.printLoading = false;

        this.usePersonalizedAverage = false;
      }
    },
    bulletinType: function (select) {
      switch (this.type) {
        case "MP":
          switch (select) {
            case 1:
              return "peda";
            case 2:
              return "bulletin";
          }
        case "MT":
          switch (select) {
            case 1:
              return "specific";
            case 2:
              return "bulletinSpec";
          }
        case "MS":
          switch (select) {
            case 1:
              return "verySpecific";
            case 2:
              return "bulletinVerySpec";
          }
      }
    },
    async getIncompleteMarks() {
      apiClient
        .get(
          "/bulletin/v2/stats/incompleteMarks/" +
          this.type +
          "/" +
          this.selectedTrimester
        )
        .then(({ data }) => {
          this.incompleteMarksStats = data;
        });
    },
    bulletinTypeText: function (type) {
      switch (type) {
        case "MP":
          return this.$t("bulletin.bulletinPedagogique");
        case "MT":
          return this.$t("bulletin.bulletinSpecifique");
        case "MS":
          return this.$t("bulletin.bulletinVerySpecifique");
      }
    },
    async updateBulletin() {
      this.tableLoading = true;
      this.loadingBulletin = true;
      apiClient
        .get(
          `/bulletin/v2/bt/${this.type}/${this.selectedStudent}/${this.selectedTrimester}`
        )
        .then(({ data }) => {
          this.bulletin = data;
          this.loadingBulletin = false;
        })
        .catch(() => console.error("failed to load bulletin for stats"))
        .finally(() => (this.tableLoading = false));
    },
    getSelectedGroup(key) {
      const menuItem = this.menuItems.find((item) => item.key === key);
      return menuItem ? menuItem.group : null;
    },
    async updateCertifParams() {
      const url = "/certification/" + this.type;
      await apiClient
        .get(url)
        .then((res) => {
          this.certifParams = res.data;
        })
        .catch((e) => {
          console.error("failed to load certifParams", e);
        });
    },
    circularColorPicker(submoduleId) {
      const submodulesIDs = this.subModuleList.map((sm) => sm._id);
      const colors = [
        "cyan",
        "red",
        "orange",
        "green",
        "blue",
        "purple",
        "pink",
      ];
      const nbColors = colors.length;
      return colors[submodulesIDs.indexOf(submoduleId) % nbColors];
    },
    confirmLeaveReload(event) {
      if (!this.updatedChanges) {
        event.returnValue = this.$t("all.unsavedchangesContent");
      }
    },
    async openFinalBulletin() {
      this.$gtag.event("Imp allBulletinAnnuel", {
        event_category: "Impression PDF",
        event_label: "Bulletin specific-NotesEleves section",
        value: 1,
      });
      this.yearlyConfig = {
        showStamp: this.showStamp,
        bulletinDate: this.bulletinDate,
        usePersonalizedAverage: this.usePersonalizedAverage,
      };
      this.visibleFinalBulletin = true;
    },
    async openAllFinalBulletin() {
      this.$gtag.event("Imp BulletinAnnuel", {
        event_category: "Impression PDF",
        event_label: "Bulletin specific-NotesEleves section",
        value: 1,
      });

      this.visibleAllFinalBulletin = true;
    },
    closeFinalBulletin() {
      this.visibleFinalBulletin = false;
    },
    closeAllFinalBulletin() {
      this.visibleAllFinalBulletin = false;
    },
    setPrintLoading(val) {
      this.printLoading = val;
    },
    moment,
    confirmeBulletinValidation() {
      const content = this.isValidatedBulletin()
        ? this.$t("bulletin.hideBulletin")
        : this.$t("bulletin.validateBulletin");
      this.$confirm({
        title: this.$t("all.sureTo"),
        content: (h) => <div style="color:red"> {content} </div>,
        onOk: () => {
          //console.log("OK");
          this.validateBulletin();
        },
        onCancel: () => {
          //console.log("Cancel");
        },
        class: "test",
      });
    },
    isValidatedBulletin() {
      // DONE
      if (this.selectedClasse) {
        const classsroom = this.classes.find(
          (item) => item._id === this.selectedClasse
        );
        const bulletin = classsroom
          ? classsroom[this.bulletinType(2)]
          : { sem1: false, sem2: false, sem3: false };
        if (this.selectedTrimester == 1 && bulletin.sem1 == true) return true;
        else if (this.selectedTrimester == 2 && bulletin.sem2 == true)
          return true;
        else if (this.selectedTrimester == 3 && bulletin.sem3 == true)
          return true;
      }
      return false;
    },
    validateBulletin() {
      // DONE
      const isValidated = this.isValidatedBulletin();
      const classsroom = this.classes.find(
        (item) => item._id === this.selectedClasse
      );
      const bulletin = classsroom
        ? classsroom[this.bulletinType(2)]
        : { sem1: false, sem2: false, sem3: false };
      if (this.selectedTrimester == 1) bulletin.sem1 = !bulletin.sem1;
      if (this.selectedTrimester == 2) bulletin.sem2 = !bulletin.sem2;
      if (this.selectedTrimester == 3) bulletin.sem3 = !bulletin.sem3;

      const bulletinField =
        this.type === "MP"
          ? "bulletin"
          : this.type === "MT"
            ? "bulletinSpec"
            : "bulletinVerySpec";
      apiClient
        .patch("/classrooms/" + this.selectedClasse, {
          data: {
            [bulletinField]: bulletin,
          },
          bulletin: {
            classroom: this.selectedClasse,
            trimester: this.selectedTrimester,
            avaliable: !isValidated,
            type: this.bulletinType(2),
          },
        })
        .then(() => {
          this.classes = this.classes.map((item) => {
            if (item._id === this.selectedClasse)
              item[this.bulletinType(2)] = bulletin;
            return item;
          });

          if (!isValidated)
            this.$message.success(
              this.$t("bulletin.validated", { name: this.selectedClassName })
            );
          else
            this.$message.success(
              this.$t("bulletin.unvalidated", { name: this.selectedClassName })
            );
        });
    },
    async sleep(timeout) {
      await new Promise((r) => setTimeout(r, timeout));
    },
    async chooseBulletinDate() {
      this.visibleBulletinDate = true;
      return new Promise(async (res) => {
        while (this.visibleBulletinDate) {
          await this.sleep(500);
        }
        res();
      });
    },
    async getModules(level) {
      await apiClient
        .post("/bulletin/v2/module/filter/marks", {
          status: "active",
          level: level,
          trimester: this.selectedTrimester,
          type: this.type,
        })
        .then((res) => {
          this.subjectsLoading = true;

          if (res.data.length == 0)
            return this.$message.warning(this.$t("error.aucModule"));
          res.data.sort((a, b) => {
            return a.order - b.order;
          });
          this.subjectList = [];
          this.listModules = res.data;
          res.data.forEach((moduleItem) => {
            moduleItem.subjects.forEach((subject) => {
              const subjectsInfo = moduleItem.subjectsInfo;
              const subsubjects = subjectsInfo[subject._id];
              subject.moduleName = moduleItem.name;
              if (subsubjects && subsubjects.sousModule)
                subject.subModule = this.subModuleList.find(
                  (sm) => String(sm._id) == String(subsubjects.sousModule)
                );
              this.subjectList.push(subject);
            });
          });
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(this.$t("error.erreur"));
          this.moduleLoading = false;
        });
    },
    tableChanged(pagination, filters, sorter, extra) {
      this.filtredTable = extra.currentDataSource;
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },

    async saveAll() {
      this.saveLoading = true;

      // check if marks are correct
      let thereError = false;
      for (const mark of this.markData) {
        if (!mark.divided) {
          if (isNaN(Number(mark.mark)) || mark.mark > 20 || mark.mark < 0) {
            thereError = true;
            break;
          }
        } else if (mark.divided) {
          let subject = this.subjectList.find(s => s._id == mark.subject)
          let subsubject = subject?.subsubjectData.find(s => s._id == mark.subsubject)

          if (subsubject && (isNaN(Number(mark.mark)) || mark.mark > subsubject.maxMark || mark.mark < 0)) {
            thereError = true;
            break;
          }
        }
      }

      if (thereError) {
        this.$message.warning(this.$t("warning.notCorrectMarks"));
        this.saveLoading = false;
        return;
      }

      const marksChanged = this.hasMarksChanged();

      // saving
      const toAddData = [];

      for (const mark of this.markData) {
        const originalMark = this.originalMarkData.find(
          (m) => {
            const { student, subject, subsubject, divided } = mark;
            m.student == student &&
              (divided && m.subsubject == subsubject) &&
              (m.subject == subsubject)
            if (divided) {
              return m.student == student &&
                (m.subsubject == subject) &&
                (m.subject == subsubject)
            } else {
              return m.student == student &&
                (!m.divided) &&
                (m.subject == subsubject)
            }
          }
        );
        if (originalMark) {
          if (Number(mark.mark) != Number(originalMark.mark))
            await apiClient
              .patch("/bulletin/v2/mark/" + originalMark._id, {
                data: {
                  mark: mark.mark,
                },
              })
              .then()
              .catch((err) => console.log(err));
        } else {
          const obj = {
            divided: mark.divided,
            student: mark.student,
            mark: mark.mark,
            trimester: this.selectedTrimester,
            classroom: this.selectedClasse,
            subject: mark.subject,
            type: "one",
          };
          if (mark.divided) obj.subsubject = mark.subsubject;
          toAddData.push(obj);
        }
      }

      await apiClient
        .put("/bulletin/v2/mark/many", {
          data: toAddData,
        })
        .catch((err) => console.log(err));

      for (const originalMark of this.originalMarkData) {
        const mark = this.markData.find(
          (m) =>
            m.student == originalMark.student &&
            ((!m.divided && m.subject == originalMark.subject) ||
              (m.divided && m.subsubject == originalMark.subsubject))
        );
        if (!mark)
          await apiClient
            .delete("/bulletin/v2/mark/" + originalMark._id)
            .then()
            .catch((err) => console.log(err));
      }

      await this.updateMarks();
      if (marksChanged && this.aiFeedbackEnabled) this.getAIRecommandation();
      this.saveLoading = false;
      this.updatedChanges = true;
      this.getIncompleteMarks();
      this.$message.success(this.$t("success.noteToutesEnregistre"));
    },

    deleteMark(id, studentId, divided) {
      this.markData = this.markData.filter(
        (m) =>
          !(
            m.student == studentId &&
            m.divided == divided &&
            (m.subsubject == id || m.subject == id)
          )
      );
      this.updatedChanges = false;
    },

    handleMarkChange(newMark, subjectId, subSubjectId, studentId, divided) {
      const mark = this.markData.find(
        (m) => {
          m.student == studentId &&
            (divided && m.subsubject == subSubjectId) &&
            (m.subject == subjectId)
          if (divided) {
            return m.student == studentId &&
              (m.subsubject == subSubjectId) &&
              (m.subject == subjectId)
          } else {
            return m.student == studentId &&
              (!m.divided) &&
              (m.subject == subjectId)
          }
        }
      );
      if (mark) mark.mark = Number(newMark);
      else {
        const obj = {
          student: studentId,
          mark: Number(newMark),
          divided: divided,
          subject: subjectId,
        };
        if (divided) obj.subsubject = subSubjectId;

        this.markData.push(obj);
      }

      this.updatedChanges = false;
    },

    getMarkValue(id, studentId, divided = false, subjectId = null) {
      const mark = this.markData.find(
        (m) =>
          m.student == studentId &&
          m.divided == divided &&
          (subjectId ? m.subject == subjectId : true) &&
          (m.subsubject == id || m.subject == id)
      );
      if (mark) return mark.mark;
      return null;
    },

    getTotalSubsubjects(record) {
      try {
        const marks = this.markData.filter((mark) => {
          return (
            mark.divided &&
            mark.subject == record._id &&
            record.subsubjectData.map((ss) => ss._id).includes(mark.subsubject)
          );
        });
        const subject = this.subjectList.find((s) => s._id == record._id);

        let total = 0;
        let subSubjectTotalCoefs = 0;
        marks.forEach((mark) => {
          let subsubjectData = subject.subsubjectData.find(
            (s) => s._id == mark.subsubject
          );
          subSubjectTotalCoefs += subsubjectData.coefMark;
          total +=
            (mark.mark * (subsubjectData.coefMark ?? 1)) /
            subsubjectData.maxMark;
        });
        return total
          ? ((total * 20) / (subSubjectTotalCoefs ?? 1)).toFixed(2)
          : "";
      } catch (error) {
        console.log(error);
      }
    },
    async handleStudentChange(val) {
      this.resetN8nFeedback();
      this.updateMarks();
      this.fetchExemptStudents();
    },

    async updateMarks() {
      this.tableLoading = true;
      await apiClient
        .post("/bulletin/v2/mark/filter", {
          query: {
            classroom: this.selectedClasse,
            trimester: this.selectedTrimester,
            student: this.selectedStudent,
            schoolarYear: this.settings.activeSchoolarYear,
            type: {
              $in: ["one"],
            },
          },
        })
        .then(({ data }) => {
          this.markData = [];
          this.originalMarkData = [];
          this.originalMarkData = data;
          data.map((mark) => {
            this.markData.push({
              student: mark.student,
              subject: mark.subject,
              subsubject: mark.subsubject,
              mark: mark.mark,
              divided: mark.divided,
            });
          });
        })
        .finally(() => (this.tableLoading = false));
      await this.updateBulletin();
      this.fetchExemptStudents();
    },

    async handleClassChange(on, value) {
      this.resetN8nFeedback();
      this.studentLoading = true;
      this.selectedStudent = "";
      this.markRefs = [];
      this.moduleLoading = true;
      this.selectedClasse = value;
      this.selectedClassName = this.classes.find(
        (item) => item._id === value
      ).name;
      this.selectedLevel = this.classes.find(
        (item) => item._id === value
      ).level;
      if (on === 'trimester') {
        this.getIncompleteMarks();
      }
      let match = {};
      match[`schoolarYearsHistory.${this.settings.activeSchoolarYear}`] = value;
      await apiClient
        .post("/students/filter", {
          query: {},
          aggregation: [
            {
              $match: match,
            },
            {
              $set: {
                classRoom: {
                  $convert: {
                    input: `$schoolarYearsHistory.${this.settings.activeSchoolarYear}`,
                    to: "objectId",
                    onError: null,
                    onNull: null,
                  },
                },
              },
            },
            {
              $lookup: {
                from: "classrooms",
                localField: "classRoom",
                foreignField: "_id",
                as: "classroom",
              },
            },
            {
              $project: {
                _id: 1,
                firstName: 1,
                lastName: 1,
                middleName: 1,
                status: 1,
                gender: 1,
                firstNameLower: { $toLower: "$firstName" },
                photo: 1,
                classroom: {
                  _id: 1,
                  name: 1,
                },
              },
            },
            {
              $sort: {
                firstNameLower: 1,
              },
            },
          ],
        })
        .then(({ data }) => {
          this.rowData = [];
          data.map((elem) => {
            try {
              this.rowData.push({
                _id: elem._id,
                key: elem._id,
                fullName: elem.firstName + (elem.middleName ? " " + elem.middleName : "") + " " + elem.lastName,
                classroom: elem.classroom[0].name,
                classroom_id: elem.classroom[0]._id,
                status: elem.status,
                gender: elem.gender,
                photo: elem.photo,
              });
            } catch { }
          });
          this.activeData = this.rowData;
          this.tableLoading = false;
          this.filtredTable = this.activeData;
          this.studentLoading = false;
        });
      //get modules
      this.getModules(this.selectedLevel);
      this.fetchTeachersAccess();
    },

    async fetchTeachersAccess() {
      const response = await apiClient.get(`/teacherAccess/${this.selectedTrimester}`);
      this.teachersAccess = response.data.filter((teacher) =>
        teacher.access.some(
          (accessItem) => accessItem.classeRoom._id === this.selectedClasse
        )
      ).map((teacher) => {
        return {
          teacher: teacher._id,
          fullName: teacher.fullName,
          appAccess: teacher.access.find(
            (accessItem) => accessItem.classeRoom._id === this.selectedClasse
          )?.appAccess,
        };
      });
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    unsavedChangesAlert(newValue, type) {
      this.$confirm({
        title: this.$t("all.unsavedchanges"),
        content: this.$t("all.unsavedchangesContent"),
        okText: this.$t("all.oui"),
        okType: "danger",
        cancelText: this.$t("action.annuler"),
        onOk: () => {
          if (type === "classe") {
            this.handleClassChange("classe", newValue);
          } else if (type === "student") {
            this.selectedStudent = newValue;
            this.selectedStudentName = this.activeData.find(
              (s) => s._id == newValue
            ).fullName;
            this.handleStudentChange(newValue);
          } else if (type === "trimester") {
            this.selectedTrimester = newValue;
            this.resetN8nFeedback();
            this.handleClassChange("classe", this.selectedClasse);
            if (this.selectedStudent) this.updateMarks();
          }
          this.updatedChanges = true;
        },
      });
    },
    hasMarksChanged() {
      if (!this.markData || !this.originalMarkData) return false;

      return this.markData.some((currentMark) => {
        const originalMark = this.originalMarkData.find(
          (mark) =>
            mark.student === currentMark.student &&
            mark.subject === currentMark.subject &&
            mark.subsubject === currentMark.subsubject &&
            mark.divided === currentMark.divided
        );

        return !originalMark || originalMark.mark !== currentMark.mark;
      });
    },
    exemptStudent(subjectId) {
      this.tableLoading = true;
      apiClient
        .put("/bulletin/v2/exempt-student", {
          student: this.selectedStudent,
          subject: subjectId,
          trimester: this.selectedTrimester,
          schoolarYear: this.settings.activeSchoolarYear,
        })
        .then(() => {
          this.deleteMark(subjectId, this.selectedStudent, false);
          this.$message.success(this.$t("success.studentExempted"));
          this.fetchExemptStudents();
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(this.$t("error.erreur"));
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    undoExemptStudent(recordId) {
      if (!recordId) return;
      const exemptStudent = this.getExemptStudentId(recordId);
      if (!exemptStudent) return;
      this.tableLoading = true;
      apiClient
        .delete(`/bulletin/v2/exempt-student/${exemptStudent}`)
        .then(() => {
          this.$message.success(this.$t("success.studentExemptionRemoved"));
          this.fetchExemptStudents();
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(this.$t("error.erreur"));
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    getExemptStudentId(subjectId) {
      if (!this.exemptStudents || !this.exemptStudents.length) return null;

      const exemptRecord = this.exemptStudents.find(
        (exempt) =>
          exempt.student._id === this.selectedStudent &&
          exempt.subject._id === subjectId &&
          exempt.trimester === Number(this.selectedTrimester)
      );

      return exemptRecord ? exemptRecord._id : null;
    },
    fetchExemptStudents() {
      apiClient
        .post("/bulletin/v2/exempt-student/filter", {
          query: {
            student: this.selectedStudent,
            trimester: this.selectedTrimester,
            schoolarYear: this.settings.activeSchoolarYear,
          },
        })
        .then((response) => {
          this.exemptStudents = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching exempt students:", error);
          this.exemptStudents = [];
        });
    },
  },
  watch: {
    selectedLevel: {
      immediate: true,
      async handler(newValue) {
        if (newValue) {
          await this.fetchAffichageBulletin();
        }
      },
    },
    selectedTrimester: {
      immediate: true,
      async handler(newValue) {
        if (newValue) {
          await this.fetchAffichageBulletin();
        }
      },
    },
  },
};
